import { Link } from 'react-router'
import { siteConfig } from '../config/site'

const description = 'Pack Print Mail partners with Arina Technologies to provide websites, hosting, digital marketing, automation and technology solutions for small businesses.'
const title = 'Pack Print Mail & Arina Technologies Partnership'
const services = [
  'Website design and development', 'eCommerce websites', 'Domain setup',
  'Website hosting', 'Business email', 'SEO', 'Digital marketing', 'Social media',
  'Google and Meta advertising', 'Business automation', 'AI solutions',
  'Online forms and workflows', 'Branding integration',
  'Printing and physical marketing through Pack Print Mail',
]
const journey = ['Branding', 'Domain', 'Website', 'Business Email', 'SEO', 'Social Media', 'Advertising', 'Print & Packaging', 'Ongoing Support']

export function PartnershipPage() {
  const canonical = `${siteConfig.siteUrl}/partners/arina-technologies`
  return <article className="marketing-page partnership-page">
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={canonical} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content={siteConfig.displayName} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={canonical} />
    <header className="legacy-page-title marketing-hero"><div className="inner-shell">
      <p>Pack Print Mail + Arina Technologies</p>
      <h1>Local Business Service. Technology Expertise.</h1>
      <p className="marketing-subtitle">Pack Print Mail partners with Arina Technologies to provide small businesses with professional websites, hosting, business email, digital marketing, automation and technology solutions.</p>
    </div></header>
    <div className="inner-shell marketing-body">
      <section className="marketing-detail">
        <h2>Why We Partner</h2>
        <p>You work directly with Pack Print Mail for your business needs. Our team is your local, customer-facing partner in Waxahachie, helping you plan your project, coordinate services and get ongoing support. We also work with customers remotely.</p>
        <p>Arina Technologies brings additional expertise in technology, web development, hosting, digital infrastructure, automation and related technical capabilities. Together, we connect practical business support with the technical skills needed to deliver it.</p>
        <p>Digital services delivered by Pack Print Mail in partnership with Arina Technologies. Your customer relationship and single point of contact remain with Pack Print Mail.</p>
      </section>
      <section aria-labelledby="partnership-services">
        <h2 id="partnership-services">Services Available Through the Partnership</h2>
        <ul className="partnership-services">{services.map((service) => <li key={service}>{service}</li>)}</ul>
        <p>We’ll confirm the services, scope and pricing for your business before work begins. <Link to="/digital-marketing">Explore our digital marketing and business services.</Link></p>
      </section>
      <section className="marketing-callout">
        <h2>End-to-End Small Business Support</h2>
        <p>Instead of working with separate web developers, marketing agencies, printers and technology vendors, businesses can work with Pack Print Mail as a single point of contact.</p>
        <ol className="partnership-journey" aria-label="Your business support journey">{journey.map((step, index) => <li key={step}><span>{step}</span>{index < journey.length - 1 && <span className="partnership-arrow" aria-hidden="true">→</span>}</li>)}</ol>
      </section>
      <section className="marketing-detail">
        <h2>Ready to Grow Your Business?</h2>
        <p>Talk with Pack Print Mail about the next step for your business.</p>
        <div className="marketing-actions">
          <Link className="service-button service-button--primary" to="/digital-marketing/packages">View Marketing Packages</Link>
          <Link className="service-button service-button--secondary" to="/digital-marketing/custom">Request a Custom Quote</Link>
        </div>
      </section>
    </div>
  </article>
}
